module.exports = __webpack_public_path__ + "media/answer.b3a64fed.mp3";